export const SCALE_TO_PERCENT = 100;
